module.exports = __webpack_public_path__ + "static/media/notify.3d6e3f9f.svg";